module.exports = Em.Handlebars.compile("{{t \'upgrade\'}}\n");